export const ADD_SERVICE_PROVIDERS_LIST = 'ADD_SERVICE_PROVIDERS_LIST';
export const ACTIVE_SERVICE_PROVIDER = 'ACTIVE_SERVICE_PROVIDER';

export const addServiceProvidersList = (serviceProviders, dispatch) => {
    dispatch({
        type: ADD_SERVICE_PROVIDERS_LIST,
        serviceProviders,
    })
};

export const activeServiceProvider = (serviceProvider, dispatch) => {
    dispatch({
        type: ACTIVE_SERVICE_PROVIDER,
        serviceProvider,
    })
};